const uniforms = {
  uDarkMode: { value: 1 },
};

export default uniforms;
